import { B01_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/B01/plasmic-props";
import { B02_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/B02/plasmic-props";
import { B02b_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/B02b/plasmic-props";
import { B03_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/B03/plasmic-props";
import { B04_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/B04/plasmic-props";
import { B05_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/B05/plasmic-props";
import { B06_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/B06/plasmic-props";
import { B07_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/B07/plasmic-props";
import { B08_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/B08/plasmic-props";
import { B09_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/B09/plasmic-props";
import { B10_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/B10/plasmic-props";
import { B12_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/B12/plasmic-props";
import { B13_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/B13/plasmic-props";
import { B14_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/B14/plasmic-props";
import { B15_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/B15/plasmic-props";
import { B16_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/B16/plasmic-props";
import { B17_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/B17/plasmic-props";
import { B18_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/B18/plasmic-props";
import { B19_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/B19/plasmic-props";
import { B20_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/B20/plasmic-props";
import { B21_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/B21/plasmic-props";
import { B22_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/B22/plasmic-props";
import { B23_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/B23/plasmic-props";

import {
  BANNER_VARIANTS,
  B_01 as BANNER_B01,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

export const BANNER_PLASMIC_PROPS = {
  variant: {
    type: "choice",
    options: BANNER_VARIANTS,
    defaultValue: BANNER_B01,
    description: "Select banner variant",
  },
  ...B01_PLASMIC_PROPS,
  ...B02_PLASMIC_PROPS,
  ...B02b_PLASMIC_PROPS,
  ...B03_PLASMIC_PROPS,
  ...B04_PLASMIC_PROPS,
  ...B05_PLASMIC_PROPS,
  ...B06_PLASMIC_PROPS,
  ...B07_PLASMIC_PROPS,
  ...B08_PLASMIC_PROPS,
  ...B09_PLASMIC_PROPS,
  ...B10_PLASMIC_PROPS,
  ...B12_PLASMIC_PROPS,
  ...B13_PLASMIC_PROPS,
  ...B14_PLASMIC_PROPS,
  ...B15_PLASMIC_PROPS,
  ...B16_PLASMIC_PROPS,
  ...B17_PLASMIC_PROPS,
  ...B18_PLASMIC_PROPS,
  ...B19_PLASMIC_PROPS,
  ...B20_PLASMIC_PROPS,
  ...B21_PLASMIC_PROPS,
  ...B22_PLASMIC_PROPS,
  ...B23_PLASMIC_PROPS,

  backgroundColor: {
    type: "string",
    defaultValue: "#f5f5f5",
    description: "Background color for content area",
  },
  id: {
    type: "string",
    defaultValue: "",
    description: "HTML id attribute",
  },
  className: {
    type: "string",
    defaultValue: "",
  },
};
